<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">
            <b-tab :title="$t('edu_programs.course_programs')" active>
              <data-table :edit-item="editItem" />
            </b-tab>
            <b-tab @click="newItem= {}" :title="$t('site.add')">
              <my-form :new-item="newItem" />
            </b-tab>
          </b-tabs>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
  <!-- end of row -->
</template>

<script>
import DataTableVue from "./components/DataTable.vue";
import FormVue from "./components/Form.vue";

export default {
  name: "EduProgramsIndex",
  components: {
    "data-table": DataTableVue,
    "my-form": FormVue,
  },
  data() {
    return {
      newItem: {},
      tab: 0,
    };
  },
  methods: {
    editItem(data) {
       delete data.item.icon;
       delete data.item.edu_season;
       delete data.item.icon_path;
       delete data.item.program_list;
       delete data.item.students;
       console.log(data.item);
      this.newItem = data.item;

      this.tab = 1;
    },
  },
};
</script>
